import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivityForModal as GetActivityForModalQuery,
    GetActivityForModalVariables as GetActivityForModalVariables,
    GetActivityForModal_activity as Activity,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_FOR_MODAL from '../queries/get-activity-for-modal.graphql';

export const useGetActivityForModal = (
    activityId: string,
    skip: boolean
): {
    activity: Activity | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetActivityForModalQuery,
        GetActivityForModalVariables
    >(GET_ACTIVITY_FOR_MODAL, {
        variables: {
            activityId,
        },
        skip,
        fetchPolicy: 'cache-and-network',
    });

    const activity = data ? data.activity : null;

    return {
        activity,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
